import React, { useState } from "react";
import PropTypes from "prop-types";
import { t } from "../../../../helpers/translator";
import { useDataFetch } from "../../customHooks/dataFetch";
import CMSApi from "../../../../services/cmsApi";
import Config from "../../../../config/main";
import { useOnClickOutside } from "../../customHooks/outSideClick";

const CasinoProviders = ({ selected, onChange }) => {
    const [open, setOpen] = useState(false);
    const [data] = useDataFetch(CMSApi.getGroupedProviderOptions, []);
    const providerRef = useOnClickOutside(() =>  open && setOpen(false), [open]);

    const onProviderClick = provName => {
        const alreadySelected = selected.includes(provName);

        if (alreadySelected) onChange(selected.filter(item => item !== provName));
        else onChange(
            Config.casino.enableMultipleProviderSelect
                ? [...selected, provName]
                : [provName]
        );

        setOpen(false);
    }

    return <div className="provider-container-column">
        <div className="mini-wrapper-p-list">
            <div className={`view-select-p`}>
                {!selected.length
                    ? <p><span>{t("all")}</span></p>
                    : selected.map(provName => <p
                        key={provName}
                        onClick={() => onProviderClick(provName)}
                    >
                        <i className="closed-p-ico" />
                        <span>{provName}</span>
                    </p>)
                }
            </div>

            <div className={`all-p-list-b ${open && "active"}`} onClick={() => setOpen(!open)} />
            
            <div className="provider-list-wrapper" ref={providerRef}>
                <p onClick={() => onChange([])}>
                    <span>{t("all")}</span>
                </p>

                {data?.options.map((prov) => <p
                    key={prov.name}
                    onClick={() => onProviderClick(prov.name)}
                >
                    <span>{prov.name}</span>
                </p>)}
            </div>
        </div>
    </div>;
};

CasinoProviders.propTypes = {
    selected: PropTypes.array.isRequired,
    onChange: PropTypes.func,
};

export default CasinoProviders;